<template>
  <div>
    <!-- string -->
    <v-text-field
      v-if="type === 'string'"
      v-model="search"
      class="ma-0 pa-0"
      :style="{ 'min-width': `calc(55px + ${width})` }"
      :outlined="outlined"
      :dense="dense"
      :filled="filled"
      flat
      hide-details
      :min-width="width"
      placeholder="Søk..."
      :label="lable"
      :clearable="clearable"
      @input="atChange"
    >
      <template v-slot:prepend-inner>
        <div>
          <v-menu v-model="showMenu" offset-y style="max-width: 600px">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">
                {{ filterClauseItems[filterClauseSelected].icon }}
              </v-icon>
            </template>

            <v-list>
              <v-list-item-group
                v-model="filterClauseSelected"
                mandatory
                color="primary"
              >
                <v-list-item v-for="(item, i) in filterClauseItems" :key="i">
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-text-field>

    <!-- date -->
    <TabelDatePicker
      class="mb-0"
      v-if="type === 'date'"
      v-model="search"
      :filterClause.sync="getFilterClause"
      hide-details
      :outlined="outlined"
      :dense="dense"
      :filled="filled"
      placeholder="Dato"
      :clearable="clearable"
      :label="lable"
      @input="atChange"
    />

    <!-- select -->

    <v-select
      v-if="type === 'select'"
      class="mb-0"
      v-model="selectedValue"
      :items="itemsSelect"
      placeholder="Velg filter"
      :label="lable"
      multiple
      :outlined="outlined"
      :dense="dense"
      :filled="filled"
      hide-details
      :clearable="clearable"
      @input="atChange"
    >
      <template v-slot:selection="{ item, index }">
        <span v-if="selectedValue && selectedValue.length === 1">{{
          item
        }}</span>
        <span v-if="index === 1"> {{ selectedValue.length }} valgt </span>
      </template>
    </v-select>

    <v-select
      v-if="type === 'boolean'"
      class="mb-0"
      v-model="selectedBoolean"
      :items="booleanItems"
      placeholder="Velg filter"
      :label="lable"
      :outlined="outlined"
      :dense="dense"
      :filled="filled"
      hide-details
      :clearable="clearable"
      @input="atChange"
    >
    </v-select>

    <!-- int -->
    <v-text-field
      v-if="type === 'int'"
      v-model="search"
      class="ma-0 pa-0"
      :style="{ 'min-width': `calc(55px + ${width})` }"
      :outlined="outlined"
      :dense="dense"
      :filled="filled"
      flat
      hide-details
      :min-width="width"
      placeholder="Søk..."
      :label="lable"
      :clearable="clearable"
      @input="atChange"
    >
      <template v-slot:prepend-inner>
        <div>
          <v-menu v-model="showMenu" offset-y style="max-width: 600px">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">
                {{ filterClauseItems[filterClauseSelected].icon }}
              </v-icon>
            </template>

            <v-list>
              <v-list-item-group
                v-model="filterClauseSelected"
                mandatory
                color="primary"
              >
                <v-list-item v-for="(item, i) in filterClauseItems" :key="i">
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-text-field>
  </div>
</template>

<script>
// import BaseBirthdayPicker from "@/components/Shared/fields/BaseBirthdayPicker";
import dataTablefilterClause from "@/helpers/data/dataTablefilterClause.json";
import TabelDatePicker from "@/components/shared/table/TabelDatePicker";
export default {
  props: {
    value: {
      required: true,
    },
    filterClause: {
      default: null,
    },
    type: {
      default: null,
    },
    items: {
      default: [],
    },
    selectData: {
      default: null,
    },
    headers: {},
    lable: {
      type: String,
      default: "",
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      booleanItems: [
        { text: "Alle", value: "" },
        { text: "Ja", value: true },
        { text: "Nei", value: false },
      ],
      showMenu: false,
      width: "0px",
    };
  },
  methods: {
    atChange() {
      if (this.headers) {
        var data = this.headers.filter((x) => x.filterValue);
        this.$emit("filter", data);
      }
    },
    setWidth(value) {
      this.width = value ? value.length + "ch" : "0ch";
    },
  },
  computed: {
    search: {
      get: function () {
        this.setWidth(this.value);
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
    itemsSelect() {
      if (
        this.items &&
        this.items.length > 0 &&
        this.type === "select" &&
        this.selectData
      ) {
        const unique = [
          ...new Set(
            this.items
              .filter((x) => x[this.selectData])
              .map((item) => item[this.selectData])
          ),
        ];
        return unique;
      }
      return [];
    },
    selectedValue: {
      get() {
        if (this.value) {
          return JSON.parse(this.value);
        }
        return this.value;
      },
      set(value) {
        //Vutify filter only accepts string as value input. To detect filter we make the array to string
        // If value is empty array, then only return string. This vil disable show all/removeFilter btn
        this.$emit("input", value.length > 0 ? JSON.stringify(value) : "");
      },
    },
    selectedBoolean: {
      get() {
        if (this.value) {
          return JSON.parse(this.value);
        }
        return this.value;
      },
      set(value) {
        //Vutify filter only accepts string as value input. To detect filter we make the boolean to string
        // If value is empty array, then only return string. This vil disable show all/removeFilter btn

        this.$emit(
          "input",
          typeof value === "boolean" ? JSON.stringify(value) : value
        );
      },
    },
    getFilterClause: {
      get() {
        return this.filterClause;
      },
      set(value) {
        this.$emit("update:filterClause", value);
      },
    },
    filterClauseSelected: {
      get() {
        return this.filterClause !== null && this.filterClauseItems
          ? this.filterClauseItems.findIndex((x) => x.id === this.filterClause)
          : 0;
      },
      set(value) {
        var newValue = this.filterClauseItems[value].id;
        this.$emit("update:filterClause", newValue);
      },
    },
    filterClauseItems() {
      if (this.type) {
        return dataTablefilterClause[this.type];
      }

      return [];
    },
  },
  components: {
    // BaseBirthdayPicker,
    TabelDatePicker,
  },
};
</script>
